import { Switch as SwitchPrimitive } from '@base-ui/react/switch';

import { cn } from '@/lib/utils';

/** PRATUS Foundations Switch — 44×24 track, 20px thumb. */
function Switch({ className, ...props }: SwitchPrimitive.Root.Props) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'tw:peer tw:relative tw:inline-flex tw:h-6 tw:w-11 tw:shrink-0 tw:items-center tw:rounded-full tw:border tw:p-px tw:transition-[color,background-color,border-color,opacity,box-shadow] tw:outline-none tw:group-has-disabled/field:opacity-50',
        'tw:border-border tw:bg-background',
        'tw:not-data-disabled:hover:border-ring',
        'tw:data-checked:border-transparent tw:data-checked:bg-primary',
        'tw:data-checked:not-data-disabled:hover:opacity-80',
        'tw:focus-visible:border-ring tw:focus-visible:shadow-[0_0_0_3px_color-mix(in_oklab,var(--ring)_50%,transparent)]',
        'tw:data-checked:focus-visible:opacity-80',
        'tw:data-disabled:cursor-not-allowed tw:data-disabled:border-transparent tw:data-disabled:bg-muted tw:data-disabled:opacity-100 tw:data-disabled:shadow-none tw:data-checked:data-disabled:bg-muted tw:data-checked:data-disabled:opacity-100',
        'tw:aria-invalid:border-destructive tw:aria-invalid:ring-3 tw:aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="tw:pointer-events-none tw:block tw:size-5 tw:rounded-full tw:bg-primary tw:shadow-none tw:transition-transform tw:data-checked:translate-x-5 tw:data-checked:bg-muted tw:data-unchecked:translate-x-0 tw:data-disabled:bg-muted-foreground"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
